import { render, staticRenderFns } from "./BuiltInGuestNotificationTalkSendPopup.vue?vue&type=template&id=8be64ece&"
import script from "./BuiltInGuestNotificationTalkSendPopup.vue?vue&type=script&lang=js&"
export * from "./BuiltInGuestNotificationTalkSendPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports